import { RideApi, Configuration, AuthApi, BillingApi } from "roro-api";
import { ACCESS_TOKEN } from "../constants";

var accessToken = null
var rideApi = null
var authApi = null
var billingApi = null

const getApiConfig = () => {
    const basePath = process.env.NODE_ENV === 'production' ?
        'https://api.myroro.ir' :
        'https://api.myroro.ir' 

    return new Configuration({
        headers: accessToken ? { "Authorization": "Bearer " + accessToken } : null,
        basePath: basePath
    })
}

export const setAuthToken = (token) => {
    if (token) {
        localStorage.setItem(ACCESS_TOKEN, token);
        accessToken = token
        console.log(localStorage.getItem(ACCESS_TOKEN));
    }
    rideApi = new RideApi(getApiConfig());
    authApi = new AuthApi(getApiConfig());
    billingApi = new BillingApi(getApiConfig())
}

setAuthToken(localStorage.getItem(ACCESS_TOKEN))

/**
 * @returns {RideApi}
 */
export const getRideApi = () => rideApi;
/**
 * @returns {AuthApi}
 */
export const getAuthApi = () => authApi;
/**
 * @returns {BillingApi}
 */
export const getBillingApi = () => billingApi;
